import * as yup from 'yup';

export type SandboxMessage =
  | { type: 'loading' }
  | { type: 'loaded' }
  | { type: 'error' }
  | { type: 'resize'; width: number; height: number };

const sandboxMessageSchema = yup.lazy(value => {
  const type = value?.type;

  if (type === 'resize') {
    return yup.object({
      type: yup.mixed<'resize'>().oneOf(['resize']).required(),
      width: yup.number().required(),
      height: yup.number().required(),
    });
  }

  return yup.object({
    type: yup.mixed<'loading' | 'loaded' | 'error'>().oneOf(['loading', 'loaded', 'error']).required(),
  });
});

export function parseSandboxMessage(data: unknown): SandboxMessage | null {
  if (typeof data !== 'string') return null;

  try {
    const parsed = JSON.parse(data);

    return sandboxMessageSchema.validateSync(parsed, { abortEarly: true, stripUnknown: true }) as SandboxMessage;
  } catch {
    return null;
  }
}
